// extracted by mini-css-extract-plugin
export var box = "_4q-0";
export var check = "_4q-1";
export var checkboxButton = "_4q-6";
export var checkboxGroup = "_4q-5";
export var disabled = "_4q-7";
export var ghost = "_4q-9";
export var input = "_4q-2";
export var label = "_4q-4";
export var normal = "_4q-8";
export var uncheck = "_4q-3";